// update state
const setNotificationsTasksAction = (payload) => {
    return {
        type: "NOTIFICATIONSTASKS",
        payload
    }
}

export default setNotificationsTasksAction;


// WEBPACK FOOTER //
// ./src/actions/setNotificationsTasksAction.js